import { Route } from "@angular/router";
import { AddArticleComponent } from "./add-article.component";

export const AddArticleRouting: Route = {
    path: "add-article",
    outlet: "sidebar",
    component: AddArticleComponent
}
